import React, { useState } from 'react';
import { ChevronDownIcon, ChevronRightIcon } from 'lucide-react';
interface FilterSidebarProps {
  selectedFilters: {
    brands: string[];
    priceRange: {
      min: number;
      max: number;
    };
    categories: string[];
    needsPrescription: boolean;
    isExpress: boolean;
    isGlobal: boolean;
    offers: string[];
  };
  onFilterChange: (filters: any) => void;
  hideCategories?: boolean;
}
export function FilterSidebar({
  selectedFilters,
  onFilterChange,
  hideCategories = false
}: FilterSidebarProps) {
  const [expandedSections, setExpandedSections] = useState({
    price: true,
    brands: true,
    categories: true,
    offers: true
  });
  const brands = ['Pampers', 'Huggies', 'Babyjoy', 'Fine Baby', 'Bambi', 'Molfix'];
  const categories = ['Baby Diapers', 'Training Pants', 'Swim Diapers', 'Overnight Diapers', 'Eco-Friendly Diapers'];
  const offers = ['On Sale', 'Special Offers', 'Buy One Get One', 'Clearance'];
  const toggleSection = (section: string) => {
    setExpandedSections({
      ...expandedSections,
      [section]: !expandedSections[section]
    });
  };
  const handleBrandToggle = (brand: string) => {
    const newBrands = selectedFilters.brands.includes(brand) ? selectedFilters.brands.filter(b => b !== brand) : [...selectedFilters.brands, brand];
    onFilterChange({
      ...selectedFilters,
      brands: newBrands
    });
  };
  const handleCategoryToggle = (category: string) => {
    const newCategories = selectedFilters.categories.includes(category) ? selectedFilters.categories.filter(c => c !== category) : [...selectedFilters.categories, category];
    onFilterChange({
      ...selectedFilters,
      categories: newCategories
    });
  };
  const handleOfferToggle = (offer: string) => {
    const newOffers = selectedFilters.offers.includes(offer) ? selectedFilters.offers.filter(o => o !== offer) : [...selectedFilters.offers, offer];
    onFilterChange({
      ...selectedFilters,
      offers: newOffers
    });
  };
  const handleReset = () => {
    onFilterChange({
      brands: [],
      priceRange: {
        min: 0,
        max: 5000
      },
      categories: [],
      needsPrescription: false,
      offers: []
    });
  };
  return <div className="bg-white rounded-xl border border-gray-200 shadow-sm" data-id="element-1339" data-mp="hcioetpvpkfi">
      {/* Price Filter */}
      <div className="border-b border-gray-100" data-id="element-1340" data-mp="2ncsbemc8abu">
        <button onClick={() => toggleSection('price')} className="flex justify-between items-center w-full p-5 text-left hover:bg-gray-50" data-id="element-1341" data-mp="2mkv5zd3e4jg">
          <h3 className="text-base font-bold text-gray-900" data-id="element-1342" data-mp="3puokjf2hwu6g">Filter By Price</h3>
          {expandedSections.price ? <ChevronDownIcon className="w-5 h-5 text-gray-500" data-id="element-1343" data-mp="3uq3x83orok1a" /> : <ChevronRightIcon className="w-5 h-5 text-gray-500" data-id="element-1344" data-mp="3fvh7kszob1jv" />}
        </button>
        {expandedSections.price && <div className="px-5 pb-5" data-id="element-1345" data-mp="3kvv9dtaolf9g">
            <div className="flex justify-between mb-2 text-sm text-gray-700" data-id="element-1346" data-mp="317gygapaomeg">
              <span data-id="element-1347" data-mp="2x6x239cjpmtd">{selectedFilters.priceRange.min} SAR</span>
              <span data-id="element-1348" data-mp="2x8q8cnj8y50u">— {selectedFilters.priceRange.max} SAR</span>
            </div>
            <div className="relative h-2 bg-gray-200 rounded-full" data-id="element-1349" data-mp="3b7zltfg2il14">
              <div className="absolute h-full w-1/3 bg-[#0066CC] rounded-full" data-id="element-1350" data-mp="3672577aphz1q"></div>
            </div>
          </div>}
      </div>
      {/* Brand Filter */}
      <div className="border-b border-gray-100" data-id="element-1351" data-mp="3g5hmyjnufvyk">
        <button onClick={() => toggleSection('brands')} className="flex justify-between items-center w-full p-5 text-left hover:bg-gray-50" data-id="element-1352" data-mp="3g4q2a3vsbin2">
          <h3 className="text-base font-bold text-gray-900" data-id="element-1353" data-mp="3oxb86jebhuuh">Brands</h3>
          {expandedSections.brands ? <ChevronDownIcon className="w-5 h-5 text-gray-500" data-id="element-1354" data-mp="7owo3voxej96" /> : <ChevronRightIcon className="w-5 h-5 text-gray-500" data-id="element-1355" data-mp="2qv0cxgk1vrd" />}
        </button>
        {expandedSections.brands && <div className="px-5 pb-5" data-id="element-1356" data-mp="1w8kadqm4pye3">
            <input type="text" placeholder="Search brands" className="w-full p-2 mb-3 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-[#0066CC]" data-id="element-1357" data-mp="1w7hknm0jm1zr" />
            <div className="space-y-2 max-h-48 overflow-y-auto" data-id="element-1358" data-mp="2ayhsppxdntvd">
              {brands.map(brand => <label key={brand} className="flex items-center cursor-pointer" data-id="element-1359" data-mp="1db9960gxsuw0">
                  <input type="checkbox" checked={selectedFilters.brands.includes(brand)} onChange={() => handleBrandToggle(brand)} className="w-4 h-4 text-[#0066CC] border-gray-300 rounded focus:ring-[#0066CC]" data-id="element-1360" data-mp="1i912myx8cp2b" />
                  <span className="ml-2 text-sm text-gray-700" data-id="element-1361" data-mp="2yoltlpj6lfio">{brand}</span>
                </label>)}
            </div>
          </div>}
      </div>
      {/* Category Filter */}
      {!hideCategories && <div className="border-b border-gray-100" data-id="element-1362" data-mp="rz0q4lvbxw7b">
          <button onClick={() => toggleSection('categories')} className="flex justify-between items-center w-full p-5 text-left hover:bg-gray-50" data-id="element-1363" data-mp="n0pgoc8y5npm"><h3 className="text-base font-bold text-gray-900" data-id="element-1364" data-mp="i8fsp1re6xpz">Categories</h3>{expandedSections.categories ? <ChevronDownIcon className="w-5 h-5 text-gray-500" data-id="element-1365" data-mp="d9mbay8zimkj" /> : <ChevronRightIcon className="w-5 h-5 text-gray-500" data-id="element-1366" data-mp="8bkwwqmi7bfe" />}</button>
          {expandedSections.categories && <div className="px-5 pb-5" data-id="element-1367" data-mp="4a7pic3rj06d"><div className="space-y-2" data-id="element-1368" data-mp="49pshd9a0hxe">{categories.map(category => <label key={category} className="flex items-center cursor-pointer" data-id="element-1369" data-mp="4cc1zifq97i9"><input type="checkbox" checked={selectedFilters.categories.includes(category)} onChange={() => handleCategoryToggle(category)} className="w-4 h-4 text-[#0066CC] border-gray-300 rounded focus:ring-[#0066CC]" data-id="element-1370" data-mp="3vgsm0bcl70as" /><span className="ml-2 text-sm text-gray-700" data-id="element-1371" data-mp="1to4fnt4nbwqs">{category}</span></label>)}</div></div>}
        </div>}
      {/* Prescription Toggle */}
      <div className="border-b border-gray-100 p-5" data-id="element-1372" data-mp="3j5htqdceqcmq">
        <label className="flex items-center justify-between cursor-pointer" data-id="element-1373" data-mp="3j4q91xkclzb8">
          <span className="text-base font-bold text-gray-900" data-id="element-1374" data-mp="3nxjcmi42z1lq">
            Needs Prescription
          </span>
          <div className="relative" data-id="element-1375" data-mp="399ep90u321wm">
            <input type="checkbox" checked={selectedFilters.needsPrescription} onChange={e => onFilterChange({
            ...selectedFilters,
            needsPrescription: e.target.checked
          })} className="sr-only peer" data-id="element-1376" data-mp="3e6y7ebtwiytu" />
            <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-[#0066CC] rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-[#0066CC]" data-id="element-1377" data-mp="3rxti7tnynq02"></div>
          </div>
        </label>
      </div>
      {/* Offers Filter */}
      <div className="border-b border-gray-100" data-id="element-1378" data-mp="ykhzgpsstowp">
        <button onClick={() => toggleSection('offers')} className="flex justify-between items-center w-full p-5 text-left hover:bg-gray-50" data-id="element-1379" data-mp="ynxe5rik8vxl">
          <h3 className="text-base font-bold text-gray-900" data-id="element-1380" data-mp="18k8t6p9jbzvq">Offers</h3>
          {expandedSections.offers ? <ChevronDownIcon className="w-5 h-5 text-gray-500" data-id="element-1381" data-mp="kuelsn7zj3iv" /> : <ChevronRightIcon className="w-5 h-5 text-gray-500" data-id="element-1382" data-mp="fwmrxnns57c1" />}
        </button>
        {expandedSections.offers && <div className="px-5 pb-5" data-id="element-1383" data-mp="tob4fs1xxxtj">
            <div className="space-y-2" data-id="element-1384" data-mp="ovhvst3cq5c6">
              {offers.map(offer => <label key={offer} className="flex items-center cursor-pointer" data-id="element-1385" data-mp="15xai3jq6vzq">
                  <input type="checkbox" checked={selectedFilters.offers.includes(offer)} onChange={() => handleOfferToggle(offer)} className="w-4 h-4 text-[#0066CC] border-gray-300 rounded focus:ring-[#0066CC]" data-id="element-1386" data-mp="3t9y812a8nlof" />
                  <span className="ml-2 text-sm text-gray-700" data-id="element-1387" data-mp="v0axhz2u4n4z">{offer}</span>
                </label>)}
            </div>
          </div>}
      </div>
      {/* Reset Button */}
      <div className="p-5" data-id="element-1388" data-mp="14ygzshsjzvad">
        <button onClick={handleReset} className="w-full py-3 bg-gray-400 text-white rounded-lg font-medium hover:bg-gray-500 transition-colors" data-id="element-1389" data-mp="14x5wej30spjs">
          Reset Filter
        </button>
      </div>
    </div>;
}